var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const styles = {
    bar: {
        position: 'absolute',
        left: '2px',
        right: '2px',
        display: 'flex',
        alignItems: 'center',
        padding: '0 6px',
        fontSize: '11px',
        fontWeight: 400,
        lineHeight: 1.2,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        borderRadius: '2px',
        transition: 'opacity 0.15s ease, box-shadow 0.15s ease',
        zIndex: 1,
    },
    barHover: {
        opacity: 0.9,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
    },
    barStart: {
        borderTopLeftRadius: '3px',
        borderBottomLeftRadius: '3px',
    },
    barEnd: {
        borderTopRightRadius: '3px',
        borderBottomRightRadius: '3px',
    },
    barReadonly: {
        cursor: 'default',
    },
    barCompact: {
        fontSize: '10px',
        padding: '0 4px',
    },
    barHoliday: {
        fontStyle: 'italic',
    },
    barHighlight: {
        boxShadow: '0 0 0 2px #ffb900 inset',
    },
    initial: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '14px',
        height: '14px',
        marginRight: '4px',
        fontSize: '9px',
        fontWeight: 600,
        borderRadius: '2px',
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        flexShrink: 0,
    },
    name: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flex: 1,
    },
    time: {
        marginLeft: '4px',
        fontSize: '10px',
        opacity: 0.8,
        flexShrink: 0,
    },
    lostLaborIcon: {
        marginLeft: '4px',
        flexShrink: 0,
    },
    holidayBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: '4px',
        padding: '0 4px',
        fontSize: '9px',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '2px',
        flexShrink: 0,
    },
};
export default styles;
//# sourceMappingURL=EventBar.styles.js.map